/**
 * Web: was the last input a keyboard? React Native Web's Pressable reports
 * `focused` after a mouse click too, so focus rings that should only follow
 * the keyboard (CSS :focus-visible) check this as well. Native: always false
 * (no focus rings). Reads the window only through the guarded listener below.
 */
import { Platform } from 'react-native'

let keyboardModality = false
let installed = false

function install() {
  if (installed || Platform.OS !== 'web' || typeof window === 'undefined') return
  installed = true
  window.addEventListener('keydown', (event) => { if (event.key === 'Tab' || event.key.startsWith('Arrow') || event.key === 'Enter' || event.key === ' ') keyboardModality = true }, true)
  window.addEventListener('pointerdown', () => { keyboardModality = false }, true)
}

/** True when a focused control should show its focus ring. */
export function showFocusRing(focused: boolean | undefined): boolean {
  install()
  return !!focused && keyboardModality
}
